export { default } from './SebastianQuestions';
